import React, { useState, useRef, useEffect } from "react";
import SubHeader from "../../layout/components/SubHeader";
import clsx from "clsx";

/**
 * ArticlesHeader - Pure Bootstrap + Bootstrap Icons + React dropdown (no Bootstrap JS required)
 */
function ArticlesHeader({
                          handleSortChange,
                          handleSearchArticles,
                          subHeadingText,
                          searchTerm,
                          updateSearchTerm,
                          handleClearSearchTerm,
                        }) {
  const [sortStatus, setSortStatus] = useState("unsorted");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSearchChange = (event) => {
    updateSearchTerm(event.target.value);
  };

  const handleSearch = () => {
    handleSearchArticles(searchTerm);
  };

  const closeDropdown = () => setDropdownOpen(false);
  const toggleDropdown = () => setDropdownOpen((s) => !s);

  const handleAscendingClick = () => {
    setSortStatus("ascending");
    handleSortChange("title", "asc");
    closeDropdown();
  };

  const handleDescendingClick = () => {
    setSortStatus("descending");
    handleSortChange("title", "desc");
    closeDropdown();
  };

  const handleLatestClick = () => {
    setSortStatus("latest");
    handleSortChange("lastModified", "asc");
    closeDropdown();
  };

  const handleOldestClick = () => {
    setSortStatus("oldest");
    handleSortChange("lastModified", "desc");
    closeDropdown();
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleDocClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleDocClick);
    } else {
      document.removeEventListener("mousedown", handleDocClick);
    }
    return () => document.removeEventListener("mousedown", handleDocClick);
  }, [dropdownOpen]);

  return (
      <>
        <SubHeader title="Articles" description={subHeadingText}>
          <div className="d-flex flex-row justify-content-end align-items-center mt-3">
            {/* Search input using input-group for proper icon placement */}
            <div className="me-3 mb-2" style={{ minWidth: "220px" }}>
              <div className="input-group input-group-sm">
              <span className="input-group-text bg-white border-end-0">
                <i className="bi bi-search fs-5 text-secondary"></i>
              </span>
                <input
                    type="text"
                    className="form-control form-control-sm border-start-0"
                    placeholder="Search Article Title"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    aria-label="Search Article Title"
                />
                {searchTerm ? (
                    <div className="input-group-append ms-2 d-flex">
                      <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary ms-2"
                          onClick={handleClearSearchTerm}
                      >
                        Clear
                      </button>
                    </div>
                ) : null}
              </div>
            </div>

            {/* React-controlled dropdown (no bootstrap JS dependency) */}
            <div className="mb-2 position-relative" ref={dropdownRef}>
              <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                  onClick={toggleDropdown}
                  aria-expanded={dropdownOpen}
                  aria-haspopup="true"
              >
                <i className="bi bi-filter fs-5"></i>
              </button>

              {/* Menu */}
              {dropdownOpen && (
                  <div
                      className="card shadow-sm position-absolute end-0 mt-2"
                      style={{ minWidth: 220, zIndex: 2000 }}
                      role="menu"
                  >
                    <div className="card-body p-2">
                      <div className="mb-2">
                        <small className="text-muted d-block mb-2">Sort by name</small>
                        <button
                            type="button"
                            className={clsx(
                                "btn btn-sm w-100 text-start mb-1",
                                sortStatus === "ascending" ? "btn-secondary" : "btn-light"
                            )}
                            onClick={handleAscendingClick}
                        >
                          <i className="bi bi-sort-alpha-down me-2"></i>Ascending
                        </button>
                        <button
                            type="button"
                            className={clsx(
                                "btn btn-sm w-100 text-start",
                                sortStatus === "descending" ? "btn-secondary" : "btn-light"
                            )}
                            onClick={handleDescendingClick}
                        >
                          <i className="bi bi-sort-alpha-up me-2"></i>Descending
                        </button>
                      </div>

                      <hr className="my-2" />

                      <div>
                        <small className="text-muted d-block mb-2">Sort by date</small>
                        <button
                            type="button"
                            className={clsx(
                                "btn btn-sm w-100 text-start mb-1",
                                sortStatus === "latest" ? "btn-secondary" : "btn-light"
                            )}
                            onClick={handleLatestClick}
                        >
                          <i className="bi bi-arrow-down me-2"></i>Latest
                        </button>
                        <button
                            type="button"
                            className={clsx(
                                "btn btn-sm w-100 text-start",
                                sortStatus === "oldest" ? "btn-secondary" : "btn-light"
                            )}
                            onClick={handleOldestClick}
                        >
                          <i className="bi bi-arrow-up me-2"></i>Oldest
                        </button>
                      </div>
                    </div>
                  </div>
              )}
            </div>
          </div>
        </SubHeader>
      </>
  );
}

export default ArticlesHeader;
